import './PaymentRefundPolicyCss.css'
import AnimatedText from '../../AnimatedText'
export default function PaymentRefundPolicyMainSection() {

    return (
        <>
            <div className="NewsMainContainer">
                <div className="ourPackageUpperSection payment-refund-policy">
                    <AnimatedText
                        tag="h2"
                        type="words"
                        y={30}
                        className="rb-title ourpackageTitle"
                    >
                        Payment & Refund Policy
                    </AnimatedText>
                </div>
                <div className="PaymentRefundPolicyContentWrapper">
                    <div className="PaymentRefundPolicyCard">
                        <div class="refund-policy-wrapper">
                            {/* <div class="refund-policy-container"> */}
                                <h1 class="refund-policy-title">Refund and Cancellation Policy</h1>

                                <p class="refund-policy-intro">
                                    Our focus is complete customer satisfaction. In the event, if you are not satisfied with our services, we will refund back the money, provided the reasons are genuine and proved after investigation. In case of dissatisfaction from our services, clients have the liberty to cancel their services and request a refund from us. Our Policy for the cancellation and refund will be as follows:
                                </p>

                                <h2 class="refund-policy-heading">Cancellation Policy</h2>

                                <p class="refund-policy-text">
                                    For Cancellations please contact us via "contact us" link in our website or call us at 033-40854085 within 3 days of payment date. If the services ordered is processed by us before requesting the cancellation then the cancellation request will be denied even if this happens within 3 days. RB diagnostic will provide the proof that the services were processed before the cancellation date and time.
                                </p>

                                <p class="refund-policy-text">
                                    If you have booked for our Home Collection or Online Doctor Appointment Service online and want to cancel your order please call us on 033-40854085/033-33823382, In case of any prior payment, we will initiate your refund after you cancel your home collection/ Dr. Appointment . The refund will be processed to your original payment method within 5-7 working days.
                                </p>

                                <h2 class="refund-policy-heading">Refund Policy</h2>

                                <p class="refund-policy-text">
                                    In case any client is not completely satisfied with our products we can provide a full refund. The refund request should be made within 7 days of the payment.
                                </p>

                                <p class="refund-policy-text">
                                    If paid by credit card, refunds will be issued to the original credit card provided at the time of purchase and in case of payment gateway payments refund will be made to the same account.
                                </p>

                                <p class="refund-policy-text">
                                    The refund will be processed to your original payment method within 5-7 working days.
                                </p>
                            {/* </div> */}
                            {/*  */}
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
